import React from "react";
import * as S from "./Button.styled";

export default ({ children, icon, ...props }) => (
  <S.Button {...props}>
    <S.Flex>{children}</S.Flex>
    {icon && <S.Icon src={icon} />}
  </S.Button>
);
